<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_v">CONTENTS</a></p><a id="page_v">
</a><p class="toc"><a id="page_v"></a><span href="#/xhtml/09_Chapter01" title="Link target outside of Sample">façade (convincing)</span></p>
<p class="toc"><span href="#/xhtml/10_Chapter02" title="Link target outside of Sample">viewer (exacting)</span></p>
<p class="toc"><span href="#/xhtml/11_Chapter03" title="Link target outside of Sample">law (careful)</span></p>
<p class="toc"><span href="#/xhtml/12_Chapter04" title="Link target outside of Sample">west (american)</span></p>
<p class="toc"><span href="#/xhtml/13_Chapter05" title="Link target outside of Sample">logic (always)</span></p>
<p class="toc"><span href="#/xhtml/14_Chapter06" title="Link target outside of Sample">empath (committed)</span></p>
<p class="toc"><span href="#/xhtml/15_Chapter07" title="Link target outside of Sample">love (ledger)</span></p>
<p class="toc"><span href="#/xhtml/16_Chapter08" title="Link target outside of Sample">education (self-disciplined)</span></p>
<p class="toc"><span href="#/xhtml/17_Chapter09" title="Link target outside of Sample">beloved (made-up)</span></p>
<p class="toc"><span href="#/xhtml/18_Chapter10" title="Link target outside of Sample">pursuit (vestibular)</span></p>
<p class="toc"><span href="#/xhtml/19_Chapter11" title="Link target outside of Sample">black mirror (slowly)</span></p>
<p class="toc"><span href="#/xhtml/20_Chapter12" title="Link target outside of Sample">war (inside)(beloved)</span></p>
<p class="toc"><span href="#/xhtml/21_Chapter13" title="Link target outside of Sample">wake (systemic)</span></p>
<p class="toc"><span href="#/xhtml/22_Chapter14" title="Link target outside of Sample">research (uncirculated)</span></p>
<p class="toc"><span href="#/xhtml/23_Chapter15" title="Link target outside of Sample">opening (patent)</span></p>
<p class="toc"><span href="#/xhtml/24_Chapter16" title="Link target outside of Sample">treason (suspect)</span></p>
<p class="toc"><span href="#/xhtml/25_Chapter17" title="Link target outside of Sample">the name anon (inevitable)</span></p>
<p class="toc"><span href="#/xhtml/26_Chapter18" title="Link target outside of Sample">interstices (longed-for)</span></p>
<p class="toc"><span href="#/xhtml/27_Chapter19" title="Link target outside of Sample">transubstantiation (awol)</span></p>
<p class="toc"><span href="#/xhtml/28_Chapter20" title="Link target outside of Sample">war (verifiable)</span></p>
<p class="toc"><span href="#/xhtml/29_Chapter21" title="Link target outside of Sample">freedom (recourse)</span></p>
<p class="toc"><span href="#/xhtml/30_Chapter22" title="Link target outside of Sample">truth (verbatim)</span></p>
<p class="toc"><span href="#/xhtml/31_Chapter23" title="Link target outside of Sample">shield (expected)</span></p>
<p class="toc"><span href="#/xhtml/32_Chapter24" title="Link target outside of Sample">war (back-and-forth)</span></p>
<p class="toc"><span href="#/xhtml/33_Chapter25" title="Link target outside of Sample">fantasy (doggy)</span></p>
<p class="toc"><span href="#/xhtml/34_Chapter26" title="Link target outside of Sample">people here (distanced)</span></p>
<p class="toc"><span href="#/xhtml/35_Chapter27" title="Link target outside of Sample">darkness (aroused)</span></p>
<p class="toct"><span href="#/xhtml/36_Notes" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="toc"><span href="#/xhtml/37_Acknowledgement" title="Link target outside of Sample"><i>Acknowledgments</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?335cc226